// Stellarium Web - Copyright (c) 2018 - Noctua Software Ltd
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

<template>
  <div style="display: flex; flex-direction: row;">
    <div class="bbn-container">
      <div v-if="showMore" class="bbn-more-con">
        <div class="bbn-more-con-row">
          <div class="bbn-con-row-inline">
            <button v-if="app != true" class="bbn-item-con" @click="() => $store.commit('setShowLocationDialog', true)">
              <img class="bbn-image" src="../assets/icon/locate.png">
              <div class="bbn-more-text">{{ $store.state.currentLocation.short_name }}</div>
            </button>
            <button v-else class="bbn-item-con">
              <img class="bbn-image" src="../assets/icon/locate.png">
              <div class="bbn-more-text">{{ $store.state.currentLocation.short_name }}</div>
            </button>
            <button class="bbn-item-con" @click="() => $store.commit('setShowPlanetsVisibilityDialog', true)">
              <img class="bbn-image" src="../assets/icon/solar-system.png">
              <div class="bbn-more-text">{{ $t('Solar System') }}</div>
            </button>
            <button class="bbn-item-con" @click="() => $store.commit('setShowViewSettingsDialog', true)">
              <img class="bbn-image" src="../assets/icon/setting.png">
              <div class="bbn-more-text">{{ $t('View Settings') }}</div>
            </button>

            <v-menu top :offset-y="true">
              <template v-slot:activator="{ on, attrs }">
                <button class="bbn-item-con" v-bind="attrs" v-on="on">
                  <v-icon class="bbn-image" small>mdi-lightbulb-on</v-icon>
                  <div class="bbn-more-text">{{ $t('Light Pollution') }}</div>
                </button>
              </template>
              <v-list dense shaped>
                <v-list-item-group v-model="selectedItem" color="primary">
                  <v-list-item v-for="index in 9" :key="index" @click="changeLPM(index)">
                    <v-list-item-title class="text-center">{{ index }}</v-list-item-title>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
            <button class="bbn-item-con" @click="setShowMore(false)">
              <img class="bbn-image" src="../assets/icon/close.png">
            </button>
          </div>
        </div>
        <div class="bbn-more-menu">
          <div class="bbn-more-menu-row">
            <button class="bbn-more-menu-col"
              @click="() => { $stel.core.atmosphere.visible = !$store.state.stel.atmosphere.visible }">
              <img v-if="$store.state.stel.atmosphere.visible" class="bbn-more-menu-image"
                src="../assets/icon/atmosphere.png">
              <img v-else class="bbn-more-menu-image" src="../assets/icon/unatmosphere.png">
              <div
                :class="$store.state.stel.atmosphere.visible ? 'bbn-more-menu-text' : 'bbn-more-menu-text bbn-more-menu-text-un'">
                {{ $t('Atmosphere') }}
              </div>
            </button>
            <button class="bbn-more-menu-col"
              @click="() => { $stel.core.landscapes.visible = !$store.state.stel.landscapes.visible }">
              <img v-if="$store.state.stel.landscapes.visible" class="bbn-more-menu-image"
                src="../assets/icon/landscape.png">
              <img v-else class="bbn-more-menu-image" src="../assets/icon/unlandscape.png">
              <div
                :class="$store.state.stel.landscapes.visible ? 'bbn-more-menu-text' : 'bbn-more-menu-text bbn-more-menu-text-un'">
                {{ $t('Landscape') }}
              </div>
            </button>
            <button class="bbn-more-menu-col"
              @click="() => { $stel.core.lines.equatorial_jnow.visible = !$store.state.stel.lines.equatorial_jnow.visible }">
              <img v-if="$store.state.stel.lines.equatorial_jnow.visible" class="bbn-more-menu-image"
                src="../assets/icon/equatorial-grid.png">
              <img v-else class="bbn-more-menu-image" src="../assets/icon/unequatorial-grid.png">
              <div
                :class="$store.state.stel.lines.equatorial_jnow.visible ? 'bbn-more-menu-text' : 'bbn-more-menu-text bbn-more-menu-text-un'">
                {{ $t('Equatorial Grid') }}
              </div>
            </button>
            <button class="bbn-more-menu-col"
              @click="() => { $stel.core.lines.azimuthal.visible = !$store.state.stel.lines.azimuthal.visible }">
              <img v-if="$store.state.stel.lines.azimuthal.visible" class="bbn-more-menu-image"
                src="../assets/icon/azimuthal-grid.png">
              <img v-else class="bbn-more-menu-image" src="../assets/icon/unazimuthal-grid.png">
              <div
                :class="$store.state.stel.lines.azimuthal.visible ? 'bbn-more-menu-text' : 'bbn-more-menu-text bbn-more-menu-text-un'">
                {{ $t('Azimuthal Grid') }}
              </div>
            </button>
            <button class="bbn-more-menu-col" @click="setNightMode(!$store.state.nightmode)">
              <img v-if="$store.state.nightmode" class="bbn-more-menu-image" src="../assets/icon/night-mode.png">
              <img v-else class="bbn-more-menu-image" src="../assets/icon/unnight-mode.png">
              <div :class="$store.state.nightmode ? 'bbn-more-menu-text' : 'bbn-more-menu-text bbn-more-menu-text-un'">
                {{ $t('Night Mode') }}
              </div>
            </button>
          </div>
          <div class="bbn-more-menu-row">
            <button class="bbn-more-menu-col"
              @click="() => { $stel.core.constellations.lines_visible = !$store.state.stel.constellations.lines_visible; $stel.core.constellations.labels_visible = !$store.state.stel.constellations.labels_visible }">
              <img v-if="$store.state.stel.constellations.lines_visible" class="bbn-more-menu-image"
                src="../assets/icon/constellations.png">
              <img v-else class="bbn-more-menu-image" src="../assets/icon/unconstellations.png">
              <div
                :class="$store.state.stel.constellations.lines_visible ? 'bbn-more-menu-text' : 'bbn-more-menu-text bbn-more-menu-text-un'">
                {{ $t('Constellations') }}
              </div>
            </button>
            <button class="bbn-more-menu-col"
              @click="() => { $stel.core.constellations.images_visible = !$store.state.stel.constellations.images_visible }">
              <img v-if="$store.state.stel.constellations.images_visible" class="bbn-more-menu-image"
                src="../assets/icon/constellations-art.png">
              <img v-else class="bbn-more-menu-image" src="../assets/icon/unconstellations-art.png">
              <div
                :class="$store.state.stel.constellations.images_visible ? 'bbn-more-menu-text' : 'bbn-more-menu-text bbn-more-menu-text-un'">
                {{ $t('Constellations Art') }}
              </div>
            </button>
            <button class="bbn-more-menu-col"
              @click="() => { $stel.core.dsos.visible = !$store.state.stel.dsos.visible }">
              <img v-if="$store.state.stel.dsos.visible" class="bbn-more-menu-image" src="../assets/icon/deep-sky.png">
              <img v-else class="bbn-more-menu-image" src="../assets/icon/undeep-sky.png">
              <div
                :class="$store.state.stel.dsos.visible ? 'bbn-more-menu-text' : 'bbn-more-menu-text bbn-more-menu-text-un'">
                {{ $t('Deep Sky Objects') }}
              </div>
            </button>
            <button class="bbn-more-menu-col"
              @click="() => { $stel.core.planets.visible = !$store.state.stel.planets.visible; $stel.core.planets.hints_visible = !$store.state.stel.planets.hints_visible }">
              <img v-if="$store.state.stel.planets.visible" class="bbn-more-menu-image" src="../assets/icon/planet.png">
              <img v-else class="bbn-more-menu-image" src="../assets/icon/unplanet.png">
              <div
                :class="$store.state.stel.planets.visible ? 'bbn-more-menu-text' : 'bbn-more-menu-text bbn-more-menu-text-un'">
                {{ $t('Planet') }}
              </div>
            </button>
            <button class="bbn-more-menu-col"
              @click="() => { $stel.core.constellations.show_only_pointed = !$store.state.stel.constellations.show_only_pointed; }">
              <img v-if="$store.state.stel.constellations.show_only_pointed" class="bbn-more-menu-image" src="../assets/icon/unconstellations.png">
              <img v-else class="bbn-more-menu-image" src="../assets/icon/constellations.png">
              <div
                :class="$store.state.stel.constellations.show_only_pointed ? 'bbn-more-menu-text bbn-more-menu-text-un' : 'bbn-more-menu-text'">
                {{ $t('All Constellations') }}
              </div>
            </button>
            <!-- <button class="bbn-more-menu-col">
              <div class="bbn-more-menu-col hidden-xs-only" @click="setFullscreen(!$store.state.fullscreen)">
                <img v-if="$store.state.fullscreen" class="bbn-more-menu-image"
                  src="../assets/icon/fullscreen-exit.png">
                <img v-else class="bbn-more-menu-image" src="../assets/icon/fullscreen.png">
                <div
                  :class="$store.state.fullscreen ? 'bbn-more-menu-text' : 'bbn-more-menu-text bbn-more-menu-text-un'">
                  {{ $t('Fullscreen') }}
                </div>
              </div>
            </button> -->
            <!-- <button class="bbn-more-menu-col"/> -->
          </div>
        </div>
      </div>
      <div v-if="!showMore" class="bbn-con-row">
        <div class="bbn-con-row-inline">
          <button class="bbn-item-con square-button" @click="setShowMore(true)">
            <img class="bbn-image" src="../assets/icon/more.png">
          </button>
          <button class="bbn-item-con square-button"
            @click="() => $store.commit('setShowSearchPlanets', !$store.state.showSearchPlanets)">
            <img class="bbn-image" src="../assets/icon/search.png">
          </button>
          <button 
            v-if="$store.state.showCompass" 
            class="bbn-item-con square-button compass-button" 
            :class="{ 'compass-active': follow }"
            @click="toggleCompass"
          >
              <v-icon class="bbn-image" :color="follow ? 'primary' : 'default'">mdi-augmented-reality</v-icon>
          </button>
          <!-- <v-menu top :offset-y="true">
            <template v-slot:activator="{ on, attrs }">
              <button class="bbn-item-con" v-bind="attrs" v-on="on">
                <v-badge content="A3" color="red lighten-1">
                  <img src="images/svg/target_types/comet.svg" alt="comet">
                </v-badge>
              </button>
            </template>
            <v-list dense shaped>
              <v-list-item-group v-model="selectedItem" color="primary">
                <v-list-item v-for="item,index in events" :key="index" @click="() => changeEvent(item.time,item.obj)">
                  <v-list-item-title class="text-center">{{ item.event }}</v-list-item-title>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu> -->
          <v-menu top :offset-y="true">
            <template v-slot:activator="{ on, attrs }">
              <button class="bbn-item-con square-button" v-bind="attrs" v-on="on">
                <v-icon class="bbn-image" color="primary">
                  mdi-meteor
                </v-icon>
                <!-- <div class="bbn-more-text">{{ $t('Meteor Shower') }}</div> -->
              </button>
            </template>
            <v-list dense shaped>
              <v-list-item v-for="(shower, code) in meteorShowers" 
                           :key="code"
                           @click="selectMeteorShower(code)">
                <v-list-item-title>{{ shower.culturalName }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <!-- 修改日出钮 -->
          <button class="bbn-item-con  square-button " @click="jumpToSunTime(sunriseTime)">
            <v-icon class="bbn-image" color="yellow">mdi-weather-sunset-up</v-icon>
          </button>
          
          <!-- 修改日落按钮 -->
          <button class="bbn-item-con  square-button " @click="jumpToSunTime(sunsetTime)">
            <v-icon class="bbn-image" color="orange">mdi-weather-sunset-down</v-icon>
          </button>
        </div>
        <button class="bbn-item-con" @click="() => $store.commit('setShowTimeButtons', !$store.state.showTimeButtons)">
          <div class="bbn-time">{{ date }} {{ time }}</div>
        </button>
      </div>
      <date-time-picker v-if="!showMore" v-model="pickerDate" :location="$store.state.currentLocation">
      </date-time-picker>
    </div>
    
    <!-- 移除日出日落对话框 -->
  </div>
</template>

<script>

import DateTimePicker from '@/components/date-time-picker-new.vue'
import Moment from 'moment'
import utils from '../../common/utils/utils'
import swh from '@/assets/sw_helpers.js'
import MeteorShowerManager from '@/assets/meteor_shower.js'
var o = new Orienter()

// let app = false
const obj = {
  model: 'mpc_comet',
  // types: [
  //   'PCo',
  //   'Com',
  //   'MPl',
  //   'SSO',
  //   '?'
  // ],
  names: [
    'NAME C/2023 A3 (Tsuchinshan-ATLAS)'
  ],
  // model_data: {},
  // culturalNames: []
}
// const obj = {
//   model: 'jpl_sso',
//   model_data: {
//     jpl_horizon_id: 301
//   },
//   names: ['NAME Moon']
// }
export default {
  components: { DateTimePicker },
  data: function () {
    return {
      showMore: false,
      app: false,
      follow: false,
      selectedItem: 0,
      events: [{
        event: '此刻彗星',
        time: new Date(),
        obj: obj
      }, {
        event: '近日点',
        time: '2024-09-27T18:00:00Z',
        obj: obj
      }, {
        event: '近地点',
        time: '2024-10-12T15:18:00Z',
        obj: obj
      }],
      sunriseTime: null,
      sunsetTime: null,
      // x: 0,
      // y: 0,
      // z: 0,
      isMobileView: false,
      timer: null,
      lastYaw: 0,
      lastPitch: 0,
      smoothingFactor: 0.1, // 可以调整这个值来改变平滑程度
      meteorManager: null,
      meteorShowers: {}
    }
  },
  mounted: function () {
    window.changeDevice = this.changeDevice
    window.changeEvent = this.changeEvent
    this.app = utils.getUrlParams('app')
    o.onOrient = function (obj) {
      // let x = 360-obj.a
      let y = obj.b - 90

      let x = obj.x
      // let z = obj.g
      if (y < -90) {
        y += 360
        x -= 180
        if (x < 0) {
          x += 360
        }
      }

      // if(obj.b<0){
      //  x  = 360 - obj.x
      // }
      // let z = obj.g
      changeDevice(x, y, 0)
      // console.log(obj)
    }

    // console.log(utils.getUrlParams('app'))
    this.updateData()
    this.timer = setInterval(this.updateData, 60000)
    this.checkMobileView()
    window.addEventListener('resize', this.checkMobileView)
    this.meteorManager = new MeteorShowerManager(this.$stel)
    this.meteorManager.init()
    this.meteorShowers = this.meteorManager.showers
  },
  beforeDestroy: function () {
    clearInterval(this.timer)
    window.removeEventListener('resize', this.checkMobileView)
    if(this.meteorManager) {
      this.meteorManager.destroy()
    }
  },
  computed: {
    time: {
      get: function () {
        return this.getLocalTime().format('HH:mm:ss')
      }
    },
    date: {
      get: function () {
        return this.getLocalTime().format('YYYY-MM-DD')
      }
    },
    fullscreenBtnImage: function () {
      return this.$store.state.fullscreen ? require('@/assets/images/svg/ui/fullscreen_exit.svg') : require('@/assets/images/svg/ui/fullscreen.svg')
    },
    pickerDate: {
      get: function () {
        const t = this.getLocalTime()
        t.milliseconds(0)
        return t.format()
      },
      set: function (v) {
        const m = Moment(v)
        m.local()
        m.milliseconds(this.getLocalTime().milliseconds())
        this.$stel.core.observer.utc = m.toDate().getMJD()
      }
    },
    formattedSunriseTime: function () {
      return this.sunriseTime ? Moment(this.sunriseTime).format('HH:mm') : '--:--'
    },
    
    formattedSunsetTime: function () {
      return this.sunsetTime ? Moment(this.sunsetTime).format('HH:mm') : '--:--'
    }
  },
  methods: {
    changeEvent: function (timeStr, object) {
      const that = this
      that.$stel.core.observer.utc = new Date(timeStr).getMJD()
      const obj = swh.skySource2SweObj(object)
      // console.log(obj)//月亮是 5995064
      swh.setSweObjAsSelection(obj)
      // swh.setSweObjAsSelection(object)
    },
    
    changeLPM: function (index) {
      const that = this
      that.$stel.core.bortle_index = index
    },
    changePointConstellations: function () {
      const that = this
      that.$stel.core.constellations = !that.$stel.core.constellations
    },
    changeDevice: function (x, y, z) {
      const that = this
      
      // 将度数转换为弧度
      let yaw = x * Math.PI / 180
      let pitch = y * Math.PI / 180
      
      // 处理万向节锁问题
      if (Math.abs(pitch) > Math.PI / 2) {
        yaw = Math.PI - yaw
        pitch = Math.sign(pitch) * (Math.PI - Math.abs(pitch))
      }
      
      // 应用平滑插值
      yaw = this.smoothAngle(yaw, this.lastYaw)
      pitch = this.smoothAngle(pitch, this.lastPitch)
      
      // 更新视角
      that.$stel.core.observer.yaw = yaw
      that.$stel.core.observer.pitch = pitch
      
      // 保存当前角度为下一帧的lastAngle
      this.lastYaw = yaw
      this.lastPitch = pitch
    },
    smoothAngle: function (newAngle, lastAngle) {
      // 处理角度跨越 -π 到 π 的情况
      let delta = newAngle - lastAngle
      if (delta > Math.PI) delta -= 2 * Math.PI
      if (delta < -Math.PI) delta += 2 * Math.PI
      
      // 应用平滑因子
      return lastAngle + delta * this.smoothingFactor
    },
    toggleCompass() {
      this.follow = !this.follow;
      if (this.follow) {
        swh.clearSelection()
        o.start();
      } else {
        o.off();
      }
    },
    // 移除或修改原有的 startCompass 方法
    // startCompass: function () {
    //   if (this.follow) {
    //     o.off()
    //   } else {
    //     o.start()
    //   }
    //   this.follow = !this.follow
    // },
    // The MomentJS time in local time
    getLocalTime: function () {
      var d = new Date()
      d.setMJD(this.$store.state.stel.observer.utc)
      const m = Moment(d)
      m.local()
      return m
    },
    locationClicked: function () {
      this.$store.commit('toggleBool', 'showLocationDialog')
    },
    setFullscreen: function (b) {
      this.$fullscreen.toggle(document.body, {
        wrap: false,
        callback: this.onFullscreenChange
      })
    },
    setNightMode: function (b) {
      this.$store.commit('toggleBool', 'nightmode')
      if (window.navigator.userAgent.indexOf('Edge') > -1) {
        document.getElementById('nightmode').style.opacity = b ? '0.5' : '0'
      }
      document.getElementById('nightmode').style.visibility = b ? 'visible' : 'hidden'
    },
    onFullscreenChange: function (b) {
      if (this.$store.state.fullscreen === b) return
      this.$store.commit('toggleBool', 'fullscreen')
    },
    setShowMore: function (visible) {
      this.showMore = visible
      this.$store.commit('setShowLocationDisplay', !visible)
    },
    calculateSunriseSunset: function () {
      const obs = this.$stel.core.observer.clone()
      const sun = this.$stel.getObj('NAME Sun')
      const today = new Date()
      obs.utc = today.getMJD()
      
      const times = sun.computeVisibility()[0]
      
      this.sunriseTime = new Date()
      this.sunriseTime.setMJD(times.rise)
      this.sunsetTime = new Date()
      this.sunsetTime.setMJD(times.set)
    },
    
    jumpToSunTime: function (time) {
      if (time) {
        this.$stel.core.observer.utc = time.getMJD()
      }
    },
    checkMobileView: function () {
      this.isMobileView = window.innerWidth <= 599
    },
    updateData: function () {
      this.calculateSunriseSunset()
      // 如果有其他需要更新的数据,也可以在这里添加
    },
    selectMeteorShower(code) {
      if (this.meteorManager) {
        this.meteorManager.createShower(code)
        this.$store.commit('setValue', {
          varName: 'meteorShowerVisible',
          newValue: true
        })
        this.meteorManager.setVisibility(true)
      }
    }
  },
  watch: {
    '$store.state.currentLocation': function () {
      this.updateData()
    },
    '$store.state.stel.observer.utc': function () {
      this.updateData()
    }
  }
}
</script>

<style lang="scss">
$bbn-fontsize-text: 12px !default;
$border-radius: 8px !default;
$bbn-con-dis: 10px !default;
$slider-height: 56px !default;
$slider-thumb-size: 18px !default;
$slider-track-width: 10px !default;
$more-menu-size: 70px !default;
$bbn-image: 15px !default;
$bbn-menu-image: 30px !default;

$bbn-fontsize-text-xs: 14px !default;
$border-radius-xs: 8px !default;
$bbn-con-dis-xs: 10px !default;
$slider-height-xs: 56px !default;
$slider-thumb-size-xs: 20px !default;
$slider-track-width-xs: 12px !default;
$more-menu-size-xs: 70px !default;
$bbn-image-xs: 18px !default;
$bbn-menu-image-xs: 35px !default;

// 新增移动端变量
$bbn-fontsize-text-mobile: 10px !default;
$border-radius-mobile: 6px !default;
$bbn-con-dis-mobile: 5px !default;
$slider-height-mobile: 40px !default;
$slider-thumb-size-mobile: 16px !default;
$slider-track-width-mobile: 8px !default;
$more-menu-size-mobile: 50px !default;
$bbn-image-mobile: 12px !default;
$bbn-menu-image-mobile: 25px !default;

// 新增变量
$bottom-margin-mobile: 10px !default;
$square-button-size-mobile: 36px !default;
$rectangle-button-height-mobile: 36px !default;
$rectangle-button-padding-mobile: 0 10px !default;
$expanded-menu-text-size-mobile: 12px !default;

button {
  outline: none;
  border: none;
}

.bbn-container {
  position: relative;
  width: 100%;
}

.v-slider {
  margin: 0 $bbn-con-dis !important;
}

.v-slider__thumb {
  width: $slider-thumb-size !important;
  height: $slider-thumb-size !important;
  left: -#{$slider-thumb-size / 2} !important;
  border: 2px solid #FFF !important;
}

.v-slider__thumb:before {
  width: 0 !important;
  height: 0 !important;
  left: 0 !important;
  top: 0 !important;
}

.v-slider__track-container {
  height: $slider-track-width !important;
  border-radius: $slider-track-width !important;
  overflow: hidden !important;
}

.bbn-con-row {
  position: absolute;
  left: $bbn-con-dis;
  right: $bbn-con-dis;
  bottom: $slider-height;
  display: flex;
  flex-direction: row;
}

.bbn-con-row-inline {
  display: flex;
  flex-direction: row;
  flex: 1;
}

.bbn-item-con {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: rgba(54, 63, 87, 0.5);
  padding: 5px 8px;
  border-radius: $border-radius;
  margin-left: $bbn-con-dis;
}

.bbn-item-con:active {
  opacity: 0.5;
}

.bbn-item-con:nth-child(1) {
  margin-left: 0;
}

.bbn-image {
  width: $bbn-image;
  height: $bbn-image;
}

.bbn-time {
  font-size: $bbn-fontsize-text;
  color: rgba(255, 255, 255, 0.8);
}

.bbn-more-con {
  position: absolute;
  left: $bbn-con-dis;
  right: $bbn-con-dis;
  bottom: $slider-height/2;
  display: flex;
  flex-direction: column;
}

.bbn-more-con-row {
  display: flex;
  flex-direction: row;
}

.bbn-more-text {
  font-size: $bbn-fontsize-text;
  color: rgba(255, 255, 255, 0.8);
  margin-left: $bbn-con-dis/2;
}

.bbn-more-menu {
  display: flex;
  flex-direction: column;
  background: rgba(54, 63, 87, 0.7);
  margin-top: $bbn-con-dis;
  border-radius: $border-radius;
  padding: $bbn-con-dis 0;
}

.bbn-more-menu-row {
  display: flex;
  flex-direction: row;
}

.bbn-more-menu-row:nth-child(1) {
  margin-bottom: $bbn-con-dis;
}

.bbn-more-menu-col {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  width: $more-menu-size;
}

.bbn-more-menu-col:active img,
.bbn-more-menu-col:active div {
  opacity: 0.5;
}

.bbn-more-menu-image {
  width: $bbn-menu-image;
  height: $bbn-menu-image;
}

.bbn-more-menu-text {
  font-size: $bbn-fontsize-text;
  color: rgba(255, 255, 255, 0.8);
  transform: scale(0.8);
}

.bbn-more-menu-text-un {
  color: rgba(138, 138, 132, 0.8);
}

@media all and (min-width: 600px) {
  .bbn-container {
    position: relative;
    display: flex;
    width: 600px;
    max-width: 600px;
  }

  .v-slider {
    margin: 0 $bbn-con-dis-xs !important;
  }

  .v-slider__thumb {
    width: $slider-thumb-size-xs !important;
    height: $slider-thumb-size-xs !important;
    left: -#{$slider-thumb-size-xs / 2} !important;
    border: 2px solid #FFF !important;
  }

  .v-slider__thumb:before {
    width: 0 !important;
    height: 0 !important;
    left: 0 !important;
    top: 0 !important;
  }

  .v-slider__track-container {
    height: $slider-track-width-xs !important;
    border-radius: $slider-track-width-xs !important;
    overflow: hidden !important;
  }

  .bbn-con-row {
    position: absolute;
    left: $bbn-con-dis-xs;
    right: $bbn-con-dis-xs;
    bottom: $slider-height-xs;
    display: flex;
    flex-direction: row;
  }

  .bbn-con-row-inline {
    display: flex;
    flex-direction: row;
    flex: 1;
  }

  .bbn-item-con {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background: rgba(54, 63, 87, 0.5);
    padding: 6px 10px;
    border-radius: $border-radius-xs;
    margin-left: $bbn-con-dis-xs;
  }

  .bbn-image {
    width: $bbn-image-xs;
    height: $bbn-image-xs;
  }

  .bbn-time {
    font-size: $bbn-fontsize-text-xs;
    color: rgba(255, 255, 255, 0.8);
  }

  .bbn-more-con {
    position: absolute;
    left: $bbn-con-dis-xs;
    right: $bbn-con-dis-xs;
    bottom: $slider-height-xs/2;
    display: flex;
    flex-direction: column;
  }

  .bbn-more-con-row {
    display: flex;
    flex-direction: row;
  }

  .bbn-more-text {
    font-size: $bbn-fontsize-text-xs;
    color: rgba(255, 255, 255, 0.8);
    margin-left: $bbn-con-dis/2;
  }

  .bbn-more-menu {
    display: flex;
    flex-direction: column;
    background: rgba(54, 63, 87, 0.7);
    margin-top: $bbn-con-dis-xs;
    border-radius: $border-radius-xs;
    padding: $bbn-con-dis-xs 0;
  }

  .bbn-more-menu-row {
    display: flex;
    flex-direction: row;
  }

  .bbn-more-menu-row:nth-child(1) {
    margin-bottom: $bbn-con-dis-xs;
  }

  .bbn-more-menu-col {
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    width: $more-menu-size-xs;
  }

  .bbn-more-menu-col:active img,
  .bbn-more-menu-col:active div {
    opacity: 0.5;
  }

  .bbn-more-menu-image {
    width: $bbn-menu-image-xs;
    height: $bbn-menu-image-xs;
  }

  .bbn-more-menu-text {
    font-size: $bbn-fontsize-text-xs;
    color: rgba(255, 255, 255, 0.8);
    transform: scale(0.8);
    white-space: nowrap;
    overflow: hidden;
  }

  .bbn-more-menu-text-un {
    color: rgba(138, 138, 132, 0.8);
  }
}

// 修改现有的媒体查询，并添加新的媒体查询
@media all and (max-width: 599px) {
  .bbn-container {
    width: 100%;
    max-width: 100%;
  }

  .bbn-con-row {
    margin-bottom: $bottom-margin-mobile; // 添加底部间隙
  }

  // 修改收缩状态下的左侧按钮样式
  .bbn-con-row-inline .bbn-item-con {
    &.square-button {
      width: $square-button-size-mobile;
      height: $square-button-size-mobile;
      padding: 0;
    }

    &.rectangle-button {
      height: $rectangle-button-height-mobile;
      padding: $rectangle-button-padding-mobile;
    }

    display: flex;
    justify-content: center;
    align-items: center;
  }

  // 统一展开状态下的按钮文字样式
  .bbn-more-menu-text {
    font-size: $expanded-menu-text-size-mobile;
    color: rgba(255, 255, 255, 0.8);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    text-align: center;
  }

  .bbn-more-menu-text-un {
    color: rgba(138, 138, 132, 0.8);
  }

  .v-slider {
    margin: 0 $bbn-con-dis-mobile !important;
  }

  .v-slider__thumb {
    width: $slider-thumb-size-mobile !important;
    height: $slider-thumb-size-mobile !important;
    left: -#{$slider-thumb-size-mobile / 2} !important;
  }

  .v-slider__track-container {
    height: $slider-track-width-mobile !important;
    border-radius: $slider-track-width-mobile !important;
  }

  .bbn-con-row {
    left: $bbn-con-dis-mobile;
    right: $bbn-con-dis-mobile;
    bottom: $slider-height-mobile;
  }

  .bbn-item-con {
    padding: 4px 6px;
    border-radius: $border-radius-mobile;
    margin-left: $bbn-con-dis-mobile;
  }

  .bbn-image {
    width: $bbn-image-mobile;
    height: $bbn-image-mobile;
  }

  .bbn-time {
    font-size: $bbn-fontsize-text-mobile;
  }

  .bbn-more-con {
    left: $bbn-con-dis-mobile;
    right: $bbn-con-dis-mobile;
    bottom: $slider-height-mobile/2;
  }

  .bbn-more-text {
    font-size: $bbn-fontsize-text-mobile;
    margin-left: $bbn-con-dis-mobile/2;
  }

  .bbn-more-menu {
    margin-top: $bbn-con-dis-mobile;
    border-radius: $border-radius-mobile;
    padding: $bbn-con-dis-mobile 0;
  }

  .bbn-more-menu-row:nth-child(1) {
    margin-bottom: $bbn-con-dis-mobile;
  }

  .bbn-more-menu-col {
    width: $more-menu-size-mobile;
  }

  .bbn-more-menu-image {
    width: $bbn-menu-image-mobile;
    height: $bbn-menu-image-mobile;
  }
}

// 新增超小屏幕的媒体查询
@media all and (max-width: 320px) {
  .bbn-item-con {
    padding: 3px 4px;
  }

  .bbn-image {
    width: 10px;
    height: 10px;
  }

  .bbn-time {
    font-size: 8px;
  }

  .bbn-more-menu-col {
    width: 40px;
  }

  .bbn-more-menu-image {
    width: 20px;
    height: 20px;
  }

  .bbn-more-menu-text {
    font-size: 8px;
  }
}

.compass-button {
  transition: all 0.3s ease;
  
  &.compass-active {
    background-color: rgba(255, 255, 255, 0.2);
    box-shadow: 0 0 10px rgba(255, 255, 255, 0.3);
  }
}

.v-icon.bbn-image {
  transition: color 0.3s ease;
}

// 可以根据需要调整颜色
.v-icon.bbn-image[color="primary"] {
  color: #4CAF50; // 或者您喜欢的任何颜色
}

.v-icon.bbn-image[color="default"] {
  color: #FFFFFF; // 或者您当前使用的默认颜色
}

.bbn-image {
  font-size: 24px; // 调整图标大小
}

@media all and (max-width: 599px) {
  .sun-times-button {
    width: 32px; // 在较小屏幕上稍微减小尺寸
    height: 32px;
  }
  
  .bbn-image {
    font-size: 20px;
  }
}

@media all and (max-width: 320px) {
  .sun-times-button {
    width: 28px; // 在更小的屏幕上进一步减小尺寸
    height: 28px;
  }
  
  .bbn-image {
    font-size: 18px;
  }
}
</style>
